export const LINKED_SDS_NO_PERMISSION_MESSAGE =
  "You do not have permission to edit the chemical this SDS is attached to";

/**
 * An SDS is part of its catalog chemicals, so editing or deleting it requires
 * write access to every chemical it's attached to. The API enforces the same rule.
 */
export function canModifyLinkedSds(document: {
  chemicalDocument?: { chemical: { canWrite: boolean } }[] | null;
}): boolean {
  return (document.chemicalDocument ?? []).every(({ chemical }) => chemical.canWrite);
}
